<template>
    <!--<iframe width="280" height="157" v-bind:src="video.videoUrl" frameborder="0" allowfullscreen></iframe>-->
    <!-- app -->
    <div class="videoPlaceHolder">
    <!--addon hover le play-->
        <div @click="showModal = true" class="videoThumbnail">
            <img class="video-thumbnail"  :src="video.imageUrl" :alt="video.name">
            <svg width="55" height="65">
                <polygon points="55,33 0,0 0,65" style="fill:rgb(0,159,227);"/>
            </svg>
        </div>

        <div v-if="showModal">
            <transition name="modal">
                <div class="modal-mask">
                    <div class="modal-wrapper">
                        <div class="modal-container videoPlayer">
                            <div class="modal-header">

                                <h3 slot="header">{{ video.name }}</h3>
                            </div>
                            <div class="modal-body">
                                <div></div>
                                <div class="resp-container">
                                    <iframe class="resp-iframe" slot="body" v-bind:src="video.videoUrl" frameborder="0" allowfullscreen></iframe>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <slot name="footer">
                                    <button class="modal-default-button" @click="showModal = false"></button>
                                </slot>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'video',
        props: ['video'],
        data: function () {
            return {
                showModal: false,
            }
        },
    }
</script>

<style>

@media screen and (max-width: 1200px) {
            .resp-container {
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;
    }

    .resp-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
}


    }
    .resp-container {
    position: relative;
    overflow: hidden;
    padding-top: 56.25%;
    }

    .resp-iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
}


    .modal-header h3 {
        color: white;
        font-size: 40px;
        text-align: center;
        margin-bottom: 0px;
    }
    
    
    .video-thumbnail {
        width: 280px;
        height: 157px;
    }
    .videoPlaceHolder
    {
        margin:5px;
        padding:0px;
        max-height:157px;



    }
    .videoPlaceHolder:hover
    {
        cursor: pointer;
    }
    
    .videoThumbnail
    {
        position:relative;
    }
    .videoThumbnail:hover img
    {
        opacity: 0.5;
    }
    .videoThumbnail svg
    {
        opacity:0.0;
        position:absolute;
        top:27.8%;
        left:-2%;
        transform:scale(1.1);
        transition-property: all; /* Active la transition */
        transition-duration: 200ms; 
    }
    .videoThumbnail:hover svg
    {
        opacity:1.0;
        left:45%;        
    }
    .videoPlayer .modal-body
    {
        position: relative;
        width: 75%;
        height: 80%;
        max-height: 80%;
        max-width: 100%;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);

    }
</style>



// WEBPACK FOOTER //
// Video.vue?26ee17da